import styled from '@emotion/styled'

import { COLORS } from '@/styles/colors'

import { LANDING_COLORS } from '../../../constants'

export type SpecRowTone = 'default' | 'cons' | 'pros'

const LABEL_BG: Record<SpecRowTone, string> = {
  default: '#EFEFEF',
  cons: '#FADDDD',
  pros: '#ADE5C2',
}

const VALUE_BG: Record<SpecRowTone, string> = {
  default: COLORS.bgWhite,
  cons: LANDING_COLORS.consCardBg,
  pros: LANDING_COLORS.prosCardBg,
}

const LABEL_TEXT: Record<SpecRowTone, string> = {
  default: COLORS.textSecondary,
  cons: LANDING_COLORS.negative,
  pros: COLORS.fgPositive,
}

const VALUE_TEXT: Record<SpecRowTone, string> = {
  default: COLORS.textTertiary,
  cons: LANDING_COLORS.negative,
  pros: COLORS.fgPositive,
}

export const SpecContainer = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  padding: 60px 0;
  background-color: ${LANDING_COLORS.bg};
`

export const SpecHeading = styled.h2`
  margin: 0;
  font-size: 30px;
  font-weight: 700;
  line-height: 30px;
  letter-spacing: -0.45px;
  text-align: center;
  color: ${COLORS.textPrimary};
`

export const SpecBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
`

export const SizeIllust = styled.img`
  width: 208px;
  height: auto;
`

export const SpecTable = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 330px;
  /* 좁은 화면에서 가로 패딩 확보 — 330px 미만 뷰포트에서 잘림 방지 */
  padding: 0 16px;
  box-sizing: border-box;

  /* 첫 행 값 셀은 상단 구분선 제거 */
  & > div:first-of-type > div:last-child {
    border-top: none;
  }
`

export const SpecRow = styled.div`
  display: flex;
  align-items: stretch;
`

export const SpecLabelCell = styled('div', {
  shouldForwardProp: (prop) => prop !== 'tone',
})<{ tone: SpecRowTone }>`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 76px;
  padding: 12px;
  white-space: nowrap;
  font-size: 14px;
  font-weight: ${({ tone }) => (tone === 'default' ? 500 : 600)};
  line-height: 14px;
  color: ${({ tone }) => LABEL_TEXT[tone]};
  background-color: ${({ tone }) => LABEL_BG[tone]};
`

export const SpecValueCell = styled('div', {
  shouldForwardProp: (prop) => prop !== 'tone',
})<{ tone: SpecRowTone }>`
  display: flex;
  flex: 1;
  min-width: 0;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  padding: 12px 16px;
  border-top: 0.5px solid ${COLORS.strokeStatic};
  background-color: ${({ tone }) => VALUE_BG[tone]};
`

export const SpecValueLine = styled('p', {
  shouldForwardProp: (prop) => prop !== 'tone',
})<{ tone: SpecRowTone }>`
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  /* 좁은 화면에서 긴 값(예: "끝부분 날카로움 (잘라서 사용 권장)")이 줄바꿈되도록 행간 확보 */
  line-height: 1.4;
  word-break: keep-all;
  color: ${({ tone }) => VALUE_TEXT[tone]};
`
